export function getOrderStatus(order) {
  let status = 0;
  if (order.OnlineOrderStatus === 2) {
    status = 1;
  } else if (
    order.OnlineOrderStatus === 4 ||
    order.OnlineOrderStatus === 5 ||
    order.OnlineOrderStatus === 10
  ) {
    status = 2;
  } else if (
    order.OnlineOrderStatus === 3 ||
    order.OnlineOrderStatus === 6 ||
    order.OnlineOrderStatus === 11
  ) {
    status = -1;
  } else if (order.OnlineOrderStatus === 9) {
    status = 3;
  } else if (
    order.OnlineOrderStatus === 1 ||
    order.OnlineOrderStatus === 7 ||
    order.OnlineOrderStatus === 8
  ) {
    status = 0;
  }
  return status;
}

var OrderTypeEnum = {
  OrderTypeEatIn: 2,
  OrderTypeTakeaway: 3,
  OrderTypeBuzzer: 9,
  OrderTypeDelivery: 10
};

export const orderTypeEnum = OrderTypeEnum;
